import produce, { enableES5 } from "immer";
enableES5();
import { Reducer } from "redux";

export enum RecipientValidationActions {
    UPDATE = "updateValidationState",
}

export interface IRecipientValidationModel {
    isRecipientValid: boolean;
    isQnARecipientValid: boolean;
}

export interface IRecipientValidationAction {
    type: RecipientValidationActions;
    payload: IRecipientValidationModel;
}

const initialValidationState: IRecipientValidationModel = {
    isRecipientValid: false,
    isQnARecipientValid: false,
};

/**
 * * To handle message selection in common place
 * @param state object of validating recipient for compose
 * @param action set valid
 * @returns state and dispatch action method
 */
export const recipientValidationReducer: Reducer<IRecipientValidationModel, IRecipientValidationAction> = produce(
    (draft: IRecipientValidationModel = initialValidationState, action: IRecipientValidationAction) => {
        switch (action.type) {
            case RecipientValidationActions.UPDATE:
                draft = action.payload;
                break;
        }
        return draft;
    }
);
